import { Component, OnInit, Injectable } from '@angular/core';
import { Router } from '@angular/router';

//import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection,
} from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

export interface User {
  email: string;
  firstName: string;
  phone: string;
  acceptPrivacy: boolean;
}

export interface Plan {
  name: string;
  maxVolunteers: number;
}

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
  env = environment;
  signupForm: FormGroup;
  awaitingResponse = false;

  freePlanDoc: AngularFirestoreDocument<Plan>;
  freePlanObservable: Observable<Plan>;
  freePlan: Plan;

  constructor(
    private fb: FormBuilder,
    public afAuth: AngularFireAuth,
    private router: Router,
    private db: AngularFirestore,
    private snackBar: MatSnackBar,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.signupForm = this.fb.group({
      email: [, Validators.required],
      password: [, [Validators.required]],
      confirmPassword: [, [Validators.required]],
      organisationName: [, Validators.required],
      // terms: [, Validators.required],
    });
    this.freePlanDoc = this.db.doc<Plan>('plans/free');
    this.freePlanObservable = this.freePlanDoc.valueChanges();
    this.freePlanObservable.subscribe((plan) => {
      this.freePlan = plan;
    });
  }

  async signup() {
    this.awaitingResponse = true;
    const signupData = this.signupForm.value;
    console.log('signupData', signupData);
    console.log('freePlan', this.freePlan);
    if (signupData.password === signupData.confirmPassword) {
      this.afAuth
        .createUserWithEmailAndPassword(signupData.email, signupData.password)
        .then(async (res) => {
          const orgId = this.db.createId();
          const userDoc = this.db.doc('users/' + res.user.uid);
          const orgDoc = this.db.doc('organisations/' + orgId);
          // const batch = this.db.firestore.batch();
          await userDoc.set(
            {
              email: signupData.email,
              organisationRef: orgDoc.ref,
            },
            { merge: true }
          );
          // batch.set(orgDoc.ref, {
          //   name: signupData.organisationName,
          //   inviteMessage: 'Wil je berichten ontvangen van @Organisatie?',
          //   plan: this.freePlan,
          // }, { merge: true });
          // batch.set(orgDoc.collection('users').doc(res.user.uid).ref, {
          //   email: signupData.email,
          //   userRef: userDoc.ref,
          //   rights: 'owner',
          // });
          const requestUrl = `${environment.functionsUrl}/httpsCreateOrg`;
          const postData = {
            creatorEmail: signupData.email,
            creatorId: res.user.uid,
            organisationId: orgId,
            organisationData: {
              name: signupData.organisationName,
              inviteMessage: 'Wil je berichten ontvangen van @Organisatie?',
              plan: this.freePlan,
            },
          };
          this.http.post(requestUrl, postData).subscribe((response) => {
            const result = response['status'] as string;
            this.awaitingResponse = undefined;
            console.log('result', result);
            if (result === 'success') {
              // this.snackBar.open('Je aanmelding is ontvangen.', '', {
              //   duration: 5000,
              // });
              console.log('Successfully signed up!', response);
              this.router.navigate(['/tasks'], {});
            } else {
              this.snackBar.open(
                'Een onbekende fout is opgetreden, neem contact op of probeer het later nog een keer.',
                '',
                {
                  duration: 10000,
                }
              );
            }
          });
          // await batch.commit();
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log('errorCode', errorCode);
          console.log('errorMessage', errorMessage);
          switch (errorCode) {
            case 'auth/email-already-in-use':
              this.snackBar.open(
                'Er is al een account aan dit e-mailadres gekoppeld.',
                '',
                {
                  duration: 5000,
                }
              );
              break;
            case 'auth/weak-password':
              this.snackBar.open(
                'Je wachtwoord moet minimaal 6 karakters zijn.',
                '',
                {
                  duration: 5000,
                }
              );
              break;
            default:
              this.snackBar.open('Er is een onbekende fout opgetreden.', '', {
                duration: 5000,
              });
          }
          this.awaitingResponse = false;
          // ...
        });
    } else {
      this.snackBar.open('Je wachtwoorden komen niet overeen', '', {
        duration: 5000,
      });
      this.awaitingResponse = false;
      console.log('Confirm password is not correct');
    }
  }
}
